/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Meta_Not_LinkedInputs */

const cs_auth_meta_not_linked = /** @type {(inputs: Auth_Meta_Not_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`K tomuto Meta účtu není propojený žádný účet. Nejdřív se přihlaste e-mailem a propojte Meta v profilu.`)
};

const en_auth_meta_not_linked = /** @type {(inputs: Auth_Meta_Not_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No account is linked to this Meta account. Sign in with email and connect Meta in profile settings first.`)
};

/**
* | output |
* | --- |
* | "No account is linked to this Meta account. Sign in with email and connect Meta in profile settings first." |
*
* @param {Auth_Meta_Not_LinkedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_meta_not_linked = /** @type {((inputs?: Auth_Meta_Not_LinkedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Meta_Not_LinkedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_meta_not_linked(inputs)
	return cs_auth_meta_not_linked(inputs)
});